export default "__VITE_ASSET__D1byR48r__"